import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BroadcasterService extends EventEmitter {
  emit(event: String) {
    super.emit(event);
  }

  emitWithParams(event: String, _param: any) {
    super.emit(event);
  }

  on(watchedEvent: String, callback: Function) {
    const subscription = this.subscribe((event: string) => {
      if (event === watchedEvent) {
        callback();
      }
    });
    return subscription;
  }
}
